/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IGym } from '../domains/Gym';
import { IPaginatedResponse } from '../domains/Pagination';
import { api } from './api';

interface IGetGymsParams {
  page?: number;
  limit?: number;
  search?: string;
}

interface IGymsListResponse extends IPaginatedResponse<IGym> {
  stats: {
    total: number;
    active: number;
  };
}

interface IWeeklyFrequencyItem {
  day_of_week: number;
  label: string;
  value: number;
}

interface IRecentActivityItem {
  type: 'new_user' | 'training_completed';
  user_fullname: string;
  training_label?: string;
  occurred_at: string;
}

interface IGymDashboard {
  gym: IGym;
  usersRegistered: number;
  exercisesRegistered: number;
  usersActiveInCurrentWeek: number;
  usersRegisteredThisMonth: number;
  weeklyFrequency: IWeeklyFrequencyItem[];
  recentActivity: IRecentActivityItem[];
}

class GymsService {
  private apiService = api;

  public async getGyms(params: IGetGymsParams = {}) {
    return this.apiService.get<IGymsListResponse>(`gyms`, { params });
  }

  public async unlock(gym_id: string) {
    return this.apiService.patch<void>(`gyms/unlock`, {
      gym_id,
    });
  }

  public async getGymDashboard(gym_id: string) {
    return this.apiService.get<IGymDashboard>(`gyms/${gym_id}/dashboard`);
  }
}

export { GymsService };
export type { IGym, IGymDashboard, IRecentActivityItem, IWeeklyFrequencyItem };
